export default {
	name: 'faqSection',
	title: 'FAQ Section',
	type: 'object',
	fields: [
		{
			name: 'title',
			title: 'Section Title',
			type: 'string',
		},
		{
			name: 'subtitle',
			title: 'Section Subtitle',
			type: 'text',
		},
		{
			name: 'faqs',
			title: 'FAQs',
			type: 'array',
			of: [
				{
					type: 'faq',
				},
			],
		},
	],
};
